import {
  createOrder,
  getOrder,
  updateOrder,
  getUploadUrl,
  getStatus,
  makeOrderPayment
} from "../api";
import {
  updateOrderState,
  updateMaxStep,
  updateStatusState
} from "../actions/order";

export const attemptCreateOrder = data => dispatch =>
  createOrder(data).then(async res => {
    localStorage.setItem("order_id", res.data.id);
    localStorage.setItem("max_step", 2);
    await dispatch(updateMaxStep(2));
    await dispatch(updateOrderState(res.data));
  });

export const attemptUpdateOrder = data => dispatch =>
  updateOrder(data).then(async res => {
    localStorage.setItem("max_step", 3);
    await dispatch(updateMaxStep(3));
    await dispatch(updateOrderState(data));
  });

export const attemptGetStatus = orderId => dispatch =>
  getStatus(orderId).then(async res => {
    if (res.data.status === "PENDING_PAYMENT") {
      localStorage.setItem("max_step", 4);
      await dispatch(updateMaxStep(4));
    }
    return res.data;
  });

export const attemptRetrieveOrder = orderId => dispatch =>
  getOrder(orderId).then(async res => {
    await dispatch(attemptGetStatus(res.data.id)).then(statusData => {
      dispatch(updateStatusState(statusData.status));
    });
    await dispatch(updateOrderState(res.data));
  });

export const attemptGetUploadUrl = orderId => dispatch =>
  getUploadUrl(orderId).then(res => {
    return res.data.url;
  });

export const attemptMakeOrderPayment = (data, id) => dispatch =>
  makeOrderPayment(data, id);
